import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Element from "element-ui";
import "../element-variables.scss";
import "@/assets/icons/index.js";
import { SinoEleUI, commonComponents, formItem, icons,utils ,directives} from "common";
import { getDicDataList, getParamdata } from "@/api/dict";
import dicData from "@/script/dict";

//查询字典数据全局方法
Vue.prototype.getDicDataList = function (dictType, dataTag, isNumber) {
  return getDicDataList(dictType, dataTag, isNumber, dicData);
};
//btnPermission 按钮权限方法，key为权限标识
Vue.prototype.btnPermission = function (key) {
  return utils.isAuth(key);
};
//按钮权限指令v-btnPermission="xxx"
Vue.directive("btnPermission", directives.btnPermission);
Vue.config.productionTip = false;
Element.FormItem.render = formItem;
Vue.use(Element);
Vue.use(SinoEleUI);
Vue.use(commonComponents);

//是否全局设置查询列表在固定高度滚动
Vue.prototype.isTableScroll = true;
Vue.prototype.btnIcons = icons;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
